module.exports = __webpack_public_path__ + "static/media/confirm_sign_up_background.10c3ce95.png";